import { useSelector } from 'react-redux'
import { useCallback } from 'react'
import { MoneyspacesSelectors } from '../../../store/moneyspaces/selectors'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Button from '../../atoms/inputs/Button'
import Label from '../../atoms/display/Label'
import List from '../../atoms/display/List'
import ListItem from '../../atoms/display/ListItem'
import Dialog from '../../atoms/feedback/Dialog'

type Props = {
  title: string
  open: boolean
  onClose: () => void
  onSelect: (moneyspaceId: string) => void
}

export default function MoneyspaceSelectDialog({ title, open, onClose, onSelect }: Props) {
  const moneyspaces = useSelector(MoneyspacesSelectors.moneyspaces)

  const handleSelect = useCallback(
    (moneyspaceId: string) => {
      onSelect(moneyspaceId)
      onClose()
    },
    [onSelect, onClose]
  )

  return (
    <Dialog open={open} onClose={onClose} title={title}>
      <FlexColumn>
        <List>
          {moneyspaces.map((moneyspace) => (
            <ListItem key={moneyspace.id} onClick={() => handleSelect(moneyspace.id)}>
              <FlexRow align="center">
                <Button height="small" size="sm" onClick={() => handleSelect(moneyspace.id)}>
                  選択
                </Button>
                <Label text={moneyspace.name} />
              </FlexRow>
            </ListItem>
          ))}
        </List>
      </FlexColumn>
    </Dialog>
  )
}
